import { apiClient } from './client'

export interface GeofencePolygon {
  type: 'Polygon'
  coordinates: number[][][]
}

export interface Geofence {
  id: string
  nombre: string
  poligono: GeofencePolygon
  horarioInicio: string | null
  horarioFin: string | null
  activo: boolean
  creadoAt: string
}

export interface GeofenceInput {
  nombre: string
  poligono: GeofencePolygon
  horarioInicio?: string
  horarioFin?: string
}

export const geofencesApi = {
  // Response is a direct array (no envelope)
  list: () => apiClient.get<Geofence[]>('/geofences').then((r) => r.data),

  create: (data: GeofenceInput) =>
    apiClient.post<Geofence>('/geofences', data).then((r) => r.data),

  update: (id: string, data: Partial<GeofenceInput>) =>
    apiClient.patch<Geofence>(`/geofences/${id}`, data).then((r) => r.data),

  remove: (id: string) =>
    apiClient.delete(`/geofences/${id}`).then((r) => r.data),
}
